import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import {OauthService} from './oauth.service';
import {App} from 'ionic-angular';
import {Http} from '@angular/http';
import {Beneficiaire} from '../models/beneficiaire/beneficiaire.model';
import {ToolsService} from './tools.service';
import { Observable } from 'rxjs';
import {AppProvider} from "../../core/app/app-provider.service";

@Injectable()
export class UserService extends OauthService {
  constructor(
    protected http: Http,
    protected app: App,
    protected appProvider: AppProvider,
    public readonly tools: ToolsService
  ) {
    super(http, app, appProvider, tools);
  }

  get() {
    const url = this.Routing.generate('api_get_utilisateur', {'_format': 'json'}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders('no-ce')})
      .map(response => response.json().data);
  }

  getBenef() {
    const url = this.Routing.generate('api_get_utilisateur_beneficiaire', {'_format': 'json'}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders('no-ce')})
      .map(response => response.json().data as Beneficiaire);
  }

  getCes() {
    const url = this.Routing.generate('api_get_utilisateurs_ces', {'_format': 'json'}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders('no-ce')})
      .map(response => response.json().data);
  }

  public getAccess() {
    const url = this.Routing.generate('api_get_utilisateur_access', {'_format': 'json'}, true);

    return this.http
      .get(`${url}`, {headers: this.updateHeaders('no-ce')})
      .map(response => response.json().data)
      .catch(this.handleErrorAccess);
  }

  private handleErrorAccess(error: any): Observable<string> {
    const contentType = error.headers && error.headers.get('Content-Type');
    const isJson = contentType && contentType.indexOf('application/json') !== -1;

    if (error && isJson) {
      error = error.json();
      const errMsg: string = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
      return Observable.of(errMsg);
    } else {
      return Observable.throw(error);
    }
  }

  public saveStatUtilisateur(): Observable<any> {
    const url = this.Routing.generate('api_get_utilisateur_utilisateur_stats', {'_format': 'json', 'appType': this.getModeApp(), 'isWeb': this.appProvider.web}, true);
    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => response.json().data)
      .catch(this.handleErrorAccess);
  }

  public saveUseActiviteUtilisateur(): Observable<any> {
    const url = this.Routing.generate('api_get_utilisateur_use_activite', {'_format': 'json', 'appType': this.getModeApp(), 'isWeb': this.appProvider.web}, true);
    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => response.json().data)
      .catch(this.handleErrorAccess);
  }

  private getModeApp(): string {
    if (this.appProvider.app === 'salarie') {
      return 'APPSAL';
    }
    else {
      return 'APPCE';
    }
  }

  public getTokenExpired(): Observable<any> {
    const url = this.Routing.generate('api_get_utilisateur_token_expired', {'_format': 'json'}, true);
    return this.http
      .get(`${url}`, {headers: this.updateHeaders()})
      .map(response => response.json())
      .catch(this.handleErrorAccess);
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/user.service.ts